var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 176,
    height: 176,
    rx: 20,
    ry: 20,
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 48,
    width: 176,
    height: 176,
    rx: 20,
    ry: 20,
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 288,
    width: 176,
    height: 176,
    rx: 20,
    ry: 20,
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 288,
    width: 176,
    height: 176,
    rx: 20,
    ry: 20,
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridOutline);
export default __webpack_public_path__ + "static/media/grid-outline.c70071c67eeb5da3d2bf8d189e201009.svg";
export { ForwardRef as ReactComponent };